import { maxAvatarUploadBytes } from "@/lib/upload-limits";

export const profileImageTypes = "image/jpeg,image/png,image/webp,image/gif";

export function profileImageError(file: File): string | null {
  if (file.size > maxAvatarUploadBytes)
    return "That image is over 5 MB. Pick a smaller one.";

  if (!profileImageTypes.split(",").includes(file.type)) {
    return "That file is not an image Softmax can use. Pick a JPEG, PNG, WebP or GIF.";
  }

  return null;
}
